const user = {
  displayName: null,
  uid: null,
  userName: '',
  userUrl: '',
  userContexts: null,
  accessToken: ""
}
export const userReducer = (state = user, action) => {
  switch (action.type) {
    case 'LOGIN':
      return Object.assign({}, state, {displayName: action.displayName, uid: action.uid, userName: action.userName, userUrl: action.userUrl})
    case 'SET_ACCESS_TOKEN':
      return Object.assign({}, state, {accessToken: action.accessToken})
    default:
      return state
  }
}

const mapping = {
  inputKeys: {},
  vocabularies: [],
  namespaceList: [],
  selectedContext:{},
  showUploadModal: false,
  isMapping: false,
  advancedMode: false,
  contextsFromVocabularies: [],
  contextsFromGist: [],
  idUrl: [], // '@id'
  vocabularyType: {}, //'@type'
  contents: {} //directInput
}
export const mappingReducer = (state = mapping, action) => {
  switch (action.type) {
    case 'SET_VOCABULARIES':
      return Object.assign({}, state, {vocabularies: action.vocabularies})
    case 'SET_INPUT_KEYS':
      return Object.assign({}, state, {inputKeys: action.inputKeys})
    case 'SET_SELECTED_CONTEXT':
      return Object.assign({}, state, {selectedContext: action.selectedContext})
    case 'SHOW_UPLOAD_MODAL':
      return Object.assign({}, state, {showUploadModal: action.showUploadModal, isMapping: action.isMapping})
    case 'SET_ADVANCED_MODE':
      return Object.assign({}, state, {advancedMode: action.advancedMode})
    case 'SET_CONTEXTS_FROM_VOCABULARIES':
      return Object.assign({}, state, {contextsFromVocabularies: action.contextsFromVocabularies})
    case 'SET_CONTEXTS_FROM_GIST':
      return Object.assign({}, state, {contextsFromGist: action.contextsFromGist})
    case 'SET_VOCABULARY_TYPE':
      return Object.assign({}, state, {
        vocabularyType: Object.assign({}, state.vocabularyType,
        {[action.keyName]: action.keyType})})
    case 'SET_CONTENTS':
      return Object.assign({}, state, {contents: action.contents})
    case 'CLEAR_VOCABULARY_TYPE':
      return Object.assign({}, state, {vocabularyType: action.vocabularyType})
    default:
      return state
  }
}

const context = {
  mapped: null,
  parsedContext: {},
  publishedContexts: []
}
export const contextReducer = (state = context, action) => {
  switch (action.type) {
    case 'SET_PARSED_CONTEXT':
      return Object.assign({}, state, {parsedContext: action.parsedContext})
    case 'SET_CONTEXT_BY_KEY':
      return Object.assign({}, state, {
        mapped: Object.assign({}, state.mapped,
            {[action.keyName]: {property: action.property, type: action.keyType}})
      })
    case 'REMOVE_CONTEXT':
      return Object.assign({}, state, {
        mapped: Object.keys(state.mapped).reduce((result, key) => {
          if (key !== action.keyName) result[key] = state.mapped[key]
          return result
        },{})
      })
    case 'SET_CONTEXT':
      return Object.assign({}, state, {mapped: action.mapped})
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/util/reducers.js